<template>
    <div>
      <el-card style="text-align: center;">
        起止时间：<el-date-picker
        v-model="time1"
        type="date"
        format="yyyy-MM-dd"
        placeholder="选择日期"
      ></el-date-picker>
        ——
        <el-date-picker
          v-model="time2"
          type="date"
          format="yyyy-MM-dd"
          placeholder="选择日期"
          style="margin-right: 2%"
        ></el-date-picker>
        下单状态：
        <el-select class="form-control" style="width: 200px ;margin-right: 20px" v-model="ta_state">
          <el-option  v-for="item in options" :key="item.value" :label="item.label" :value="item.value"  >{{item.label,item.value}}</el-option>
        </el-select>
        关键字：
        <el-input style="width: 15%;margin-right: 2%" type="text" placeholder="客户号/客户名称" v-model="accountName" />
        <el-button icon="el-icon-search" type="success" @click="save">搜索</el-button>
      </el-card>
      <div style="width: 80%;margin: 20px auto;" >
        <p v-model="ta_num">统计注册用户：{{this.ta_num}} 个</p>
      </div>
      <el-table :data="user" class="tb-edit" style="width: 80%;margin: 20px auto;" >
        <el-table-column label="序号" min-width="12%">
          <template slot-scope="scope">
            <el-button type="text"
                       @click="rowClick(scope.row)"
            >{{scope.$index + 1}}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="tu_username" label="客户名称" min-width="24%">
        </el-table-column>
        <el-table-column prop="tu_phone" label="客户电话" min-width="24%">
        </el-table-column>
        <el-table-column prop="ta_account" label="客户号" min-width="24%">
        </el-table-column>
        <el-table-column prop="ta_address" label="客户地址" min-width="24%">
        </el-table-column>
        <el-table-column prop="ta_state" label="下单状态" min-width="24%">
          <template slot-scope="scope">
            <p v-if="scope.row.ta_state == 0">未下单</p>
            <p v-else>已下单</p>
          </template>
        </el-table-column>
        <el-table-column label="下单时间" min-width="24%">
          <template slot-scope="scope">
            <p v-if="scope.row.to_outTime == null"></p>
            <p v-else>{{scope.row.to_outTime | moment}}</p>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="24%">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-view" size="small"  @click="see(scope.row)">查看全部</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: center;margin-top: 20px;">
        <!--分页组件-->
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
</template>

<script>
    export default {
      data(){
        return {
          user: [],
          options:[
            {label:'请选择',value:null},
            {label:'未下单',value:0},
            {label:'已下单',value:1}
          ],
          startDate:null,
          endDate:null,
          time1:null,
          time2:null,
          ta_state:'',
          accountName:'',
          ta_num:null,
          currentPage: 1,
          pageSize: 20,
          total: 0,
        }
      },
      mounted() {
        this.handleCurrentChange();
        this.getNumber();
      },
      methods: {
        see(row){
          this.accountName=row.tu_username
          this.save()
        },
        getTotal(){
          this.$inbound.post({
            interfaceId: 'address/getTotal',
            data:{
              time1:this.time1,
              time2:this.time2,
              to_state:this.to_state,
              accountName:this.accountName,
            }
          }).then(response => {
            this.total=response
          }).catch(error => {
            console.log(error)
          })
        },
        getNumber(){
          this.$inbound.post({
            interfaceId: 'address/selectNumber',
          }).then(response => {
            this.ta_num=response
          }).catch(error => {
            console.log(error)
          })
        },
        rowClick(row){
          // console.log(row.ta_account)
          this.$router.replace({
            path:'Order',
            query:{
              ta_account:row.ta_account
            }
          })
        },
        //获取开始时间
        getStartDate() {
          const d = new Date(this.time1);
          let year = d.getFullYear();
          let month = d.getMonth() + 1;
          let day = d.getDate();
          this.startDate = year + '-' + month + '-' + day;
        },
        //获取结束时间
        getEndDate() {
          const d = new Date(this.time2);
          let year = d.getFullYear();
          let month = d.getMonth() + 1;
          let day = d.getDate();
          this.endDate = year + '-' + month + '-' + day;
        },
        save(){
         this.handleCurrentChange()
        },
        //获取用户信息
        handleCurrentChange(val){
          this.getTotal()
          this.currentPage=val
          this.$inbound.post({
            interfaceId: 'address/selectRowAddress',
            data:{
              time1:this.time1,
              time2:this.time2,
              ta_state:this.ta_state,
              accountName:this.accountName,
              page:this.currentPage,
            }
          }).then(response => {
            this.user=response
          }).catch(error => {
            console.log(error)
          })
        }
      }
    }
</script>

<style scoped>

</style>
